import { Component, input, OnChanges, OnInit, output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { ButtonComponent } from '../../../forms/button/button.component';

@Component({
    selector: 'app-content-paginator-cabinet',
    templateUrl: './content-paginator.component.html',
    styleUrl: './content-paginator.component.scss',
    encapsulation: ViewEncapsulation.ShadowDom,
    imports: [ButtonComponent]
})
export class ContentPaginatorCabinetComponent implements OnInit, OnChanges {
  page = input<number>(1);
  pagination = input.required<{ total: number; pageSize: number; totalPages: number; page: number }>();
  pageChange = output<number>();

  ngOnInit(): void {
    const p = this.pagination();
    if (p) {
      p.page = Number(p.page);
      p.pageSize = Number(p.pageSize);
      p.total = Number(p.total);
      p.totalPages = Number(p.totalPages);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['pagination']) {
      const p = this.pagination();
      p.page = Number(p.page);
      p.pageSize = Number(p.pageSize);
      p.total = Number(p.total);
      p.totalPages = Number(p.totalPages);
    }
  }

  get pageMin(): number {
    const p = this.pagination();
    return Math.min(p.page * p.pageSize, p.total);
  }

  onPageChange(newPage: number): void {
    this.pageChange.emit(newPage);
  }

  getPageNumbers(): number[] {
    const p = this.pagination();
    if (!p?.totalPages) return [];

    const totalPages = p.totalPages;
    const currentPage = p.page;
    const delta = 2; // Show 2 pages before and after current page

    let start = Math.max(1, currentPage - delta);
    let end = Math.min(totalPages, currentPage + delta);

    // Adjust start and end to always show 5 pages if possible
    if (end - start < 4) {
      if (start === 1) {
        end = Math.min(totalPages, start + 4);
      } else if (end === totalPages) {
        start = Math.max(1, end - 4);
      }
    }

    const pages = [];
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  }
}
